import React, { useState, useEffect } from "react";
import Select from 'react-select';
import styles from "./Resources.module.css";
import ImportImageModal from "../../Components/Modals/ImportModal/ImportImageModal";
import ImportLogoModal from "../../Components/Modals/ImportModal/ImportLogoModal";
import { connect, useDispatch } from "react-redux";
import AddResources from "../../Components/Modals/AddResourcesModal/AddResourceModal";
import { useLocation } from "react-router-dom";
import { setCurrentRoute } from "../../Redux/actions";


import {
  fetchResources,
  createLocation,
  createBudget,
  deleteCarouselImage,
  createLeadSource,
  deleteLocation,
  deleteBudget,
  deleteLeadSource,
  editLocation,
  editLeadSource,
  editBudget,
  createCommercialType,
  createResidentialType,
  editResType,
  editCommType,
  deleteResidential,
  deleteComType,
  createTransferReason,
  deleteLogoImage,
  createBusinessVertical,
  deleteBusinessVertical,
  editBusinessVertical,
  createAPIFormName,
  editAPIForms,
  deleteAPIForm,
  deleteLocationMongo,
  deleteBudgetMongo,
  deleteLeadSourceMongo,
  deleteResidentialMongo,
  deleteComTypeMongo,
  deleteBusinessVerticalMongo,
  editBudgetMongo,
  editLeadSourceMongo,
  editResTypeMongo,
  editCommTypeMongo,
  editBusinessVerticalMongo,
  editLocationMongo,
  createCustomTemplate,
  deleteTemplateMongo,
  editCustomTemplate,
  createState,
  editState,
  deleteState,
  createIndustrialType,
  createInstitutionalType,
  editIndustrialTypeMongo,
  editInstitutionalTypeMongo,
  deleteIndustrialMongo,
  deleteInstitutionalMongo,
  fetchResourcesMongo,
  createResourceMongo,
  deleteResourceMongo
} from "../../Services/resources";
import { getDateString,getDateString3 } from "../../Values/utils";
import { showSnackbarAction } from "../../Redux/actions";
import Loading from "../../Components/Loading/Loading";
import { MdDelete } from "react-icons/md";

import { FiEdit3 } from "react-icons/fi";
import EditResources from "../../Components/Modals/AddResourcesModal/EditResourceModal";
import * as ReactBootStrap from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import Image from 'react-bootstrap/Image';
import { themeColors } from "../../Components/theme";
import ImportTemplateModal from "../../Components/Modals/ImportModal/ImportTemplateModal";
import axios from "axios";
import { url } from "../../Values/constants";
import EditTemplateModal from "../../Components/Modals/ImportModal/EditTemplateModal";
import Dropdown from "../../Components/DropDown/Dropdown";
import Label from "../../Components/Label";
import axiosHandler from "../../Services/axiosHandler";
import { googleAnalytics, googleAnalyticsCTAClick } from "../../Services/users";

const Resources = ({ history, user, theme, organizationData, authToken, panel, userPreference,organizationResources }: any) => {
  const [openLocation, setOpenLocation] = useState(false);
  const [openBudget, setOpenBudget] = useState(false);
  const [openLeadSource, setOpenLeadSource] = useState(false);
  const [openBusinessVertical, setOpenBusinessVertical] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [openCommercial, setOpenCommercial] = useState(false);
  const [openResidential, setOpenResidential] = useState(false);
  const [openTransferReason, setOpenTransferReason] = useState(false);
  const [isGACalled, setIsGACalled] = useState<any>(false);
  const [editModal, setEditModal] = useState(false);
  const [editValue, setEditValue] = useState("");
  const [editObj, setEditObj] = useState<{[key: string]: string}>({});
  const [editModalType, setEditModalType] = useState<
    "Location" | "Budget" | "Lead Source" | "Residential" | "Commercial" | "Business Vertical" | "API Forms" | "State" | 'Institutional' | 'Industrial'
  >("Location");
  const [importImageModal, setImportImageModal] = useState(false);
  const [importLogoModal, setImportLogoModal] = useState(false);
  const [locationsList, setLocationsList] = useState<any[] | undefined>(
    undefined
  );
  const [budgetsList, setBudgetsList] = useState<any[] | undefined>(undefined);
  const [leadSourceList, setLeadSourceList] = useState<any[] | undefined>(
    undefined
  );
  const [businessVerticalList, setBusinessVerticalList] = useState<any[] | undefined>(
    undefined
  );
  const [formNamesList, setFormNamesList] = useState<any[] | undefined>(
    undefined
  );
  const [carouselList, setCarouselList] = useState<any[] | undefined>(
    undefined
  );
  const [logoList, setLogoList] = useState<any[] | undefined>(
    undefined
  );
  const [comTypes, setComTypes] = useState<any[] | undefined>(undefined);
  const [resTypes, setResTypes] = useState<any[] | undefined>(undefined);
  const [transferReasons, setTransferReasons] = useState<any[] | undefined>(
    undefined
  );
  const [load, setLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [locationNames, setLocationNames] = useState<any[]>([]);
  const [openTemplateModal, setOpenTemplateModal] = useState(false);
  const [editTemplateModal, setEditTemplateModal] = useState(false);
  const [templatesList, setTemplatesList] = useState<any[] | undefined>(
    undefined
  );
  const [templateName, setTemplateName] = useState("");
  const [templateDetail, setTemplateDetail] = useState("");
  const [templateID, setTemplateID] = useState('');
  const [openState, setOpenState] = useState(false);
  const [stateList, setStateList] = useState<any[] | undefined>(undefined);
  const [stateNames, setStateNames] = useState<any[]>([]);
  const [weights, setWeights] = useState<any[]>([1, 2, 3, 4, 5]);
  const [negativeWeights, setNegativeWeights] = useState<any[]>([0, -1, -2, -3])
  const [callDialed, setCallDialed] = useState<any>([]);
  const [wonLeads, setWonLeads] = useState<any>([]);
  const [interested, setInterested] = useState<any>([]);
  const [promptness, setPromptness] = useState<any>([]);
  const [siteVisit, setSiteVisit] = useState<any>([]);
  const [industrialTypes, setIndustrialTypes] = useState<any[] | undefined>(undefined);
  const [institutionalTypes, setInstitutionalTypes] = useState<any[] | undefined>(undefined);
  const [openIndustrial, setOpenIndustrial] = useState(false);
  const [openInstitutional, setOpenInstitutional] = useState(false);
   const [cRoute,setCRoute]=useState("") 
         
              
                   const location = useLocation();
                    
                      useEffect(() => {
                        dispatcher(setCurrentRoute(location.pathname))
                        setCRoute(location.pathname)
                      }, [location]);
  

  const ORG_RESOURCE = [
    "custom_templates", "budgets", "carousel", "comTypes", "leadSources",
    "locations", "permission", "industrialTypes", "institutionalTypes", "states",
    "resTypes", "apiForms", "transferReasons", "businessVertical"
  ]

  // useEffect(() => {
  //   if (user.organization_id) {
  //     const unsub = fetchResources(
  //       (data) => setLocationsList(data),
  //       (data) => setBudgetsList(data),
  //       (data) => setCarouselList(data),
  //       (data) => setLeadSourceList(data),
  //       (data) => setComTypes(data),
  //       (data) => setResTypes(data),

  //       user.organization_id,
  //       (data) => setTransferReasons(data),
  //       (data) => setLogoList(data),
  //       (data) => setBusinessVerticalList(data),
  //       (data) => setFormNamesList(data),
  //       (data) => setStateList(data),
  //       (data) => setIndustrialTypes(data),
  //       (data) => setInstitutionalTypes(data),
  //     );
  //     return () => {
  //       unsub();
  //     };
  //   }
  // }, [user,loading]);
  
  // console.log("organizationResources Rishabh 11111111111",organizationResources)


  useEffect(() => {
    fetchResourcesMongo(
      organizationResources,
      (data) => setLocationsList(data),
      (data) => setBudgetsList(data),
      (data) => setCarouselList(data),
      (data) => setLeadSourceList(data),
      (data) => setComTypes(data),
      (data) => setResTypes(data),
      user.organization_id
      , authToken,
      (data) => setTransferReasons(data),
      (data) => setLogoList(data),
      (data) => setBusinessVerticalList(data),
      (data) => setFormNamesList(data),
      (data) => setStateList(data),
      (data) => setIndustrialTypes(data),
      (data) => setInstitutionalTypes(data),
      (data) => setTemplatesList(data)
    )
  }, [user, loading,organizationResources])

  // useEffect(()=>{
  //   console.log("settransferReasons",transferReasons)
  //   console.log("setcourasellist",carouselList)
  //   console.log("setleadSource",leadSourceList)
  // },[user])

  // useEffect(()=>{
  //   if(user.organization_id){
  //     fetchData()
  //   }
  // },[user,authToken])


  // const fetchData = async () => {
  //   try {
  //     setLoad(true);
  //     axios.defaults.headers.common["x-access-token"] = authToken
  //     let res = await axios.post(url + '/organizationResources/get', {
  //       organization_id: user.organization_id
  //     })

  //     setTemplatesList(res.data.data.custom_templates)
  //     setTemplateName(res.data.data.custom_templates.template_name)
  //   }
  //   catch (error) {}
  // }

  const dispatcher = useDispatch();
  const deleteImage = async (index: number, image_name: string) => {
    if (carouselList) {
      setLoad(true);
      await deleteCarouselImage(
        user.organization_id,
        image_name,
        carouselList,
        index,
        dispatcher,
        user,
        panel = "resource",
        authToken
      );
      setLoad(false);
    }
  };

  const deleteImageLogo = async (index: number, image_name: string) => {
    if (logoList) {
      setLoad(true);
      await deleteLogoImage(
        user.organization_id,
        image_name,
        logoList,
        index,
        dispatcher,
        user,
        panel = "resource",
        authToken
      );
      setLoad(false);
    }
  };

  const deleteLocationFirebase = (location: string, index: number) => {
    if (locationsList) {
      setLoad(true);
      // deleteLocation(
      //   location,
      //   user.organization_id,
      //   locationsList,
      //   index,
      //   dispatcher,
      //   (data) => setLoad(data)
      // );
      deleteLocationMongo(
        location,
        user.organization_id,
        locationsList,
        index,
        dispatcher,
        (data) => setLoad(data),
        authToken,
        user,
        panel = "resource"
      );
    }
  };

  const deleteBudgetFirebase = (budget: string, index: number) => {
    if (budgetsList) {
      setLoad(true);

      // deleteBudget(
      //   budget,
      //   user.organization_id,
      //   budgetsList,
      //   index,
      //   dispatcher,
      //   (data) => setLoad(data)
      // );
      deleteBudgetMongo(
        budget,
        user.organization_id,
        budgetsList,
        index,
        dispatcher,
        (data) => setLoad(data),
        authToken,
        user,
        panel = "resource"
      );
    }
  };

  const deleteLeadSourceFirebase = (leadSource: string, index: number) => {
    if (leadSourceList) {
      setLoad(true);
      // deleteLeadSource(
      //   leadSource,
      //   user.organization_id,
      //   leadSourceList,
      //   index,
      //   dispatcher,
      //   (data) => setLoad(data)
      // );
      deleteLeadSourceMongo(
        leadSource,
        user.organization_id,
        leadSourceList,
        index,
        dispatcher,
        (data) => setLoad(data),
        authToken,
        user,
        panel = "resource"
      );
    }
  };

  const deleteIndustrialType = (industrial: string, index: number) => {
    if (industrialTypes) {
      setLoad(true);
      deleteIndustrialMongo(
        industrial,
        user.organization_id,
        industrialTypes,
        index,
        dispatcher,
        (data) => setLoad(data),
        authToken,
        user,
        panel = "resource"
      );
    }
  };
  const deleteInstitutionalType = (institutional: string, index: number) => {
    if (institutionalTypes) {
      setLoad(true);
      deleteInstitutionalMongo(
        institutional,
        user.organization_id,
        institutionalTypes,
        index,
        dispatcher,
        (data) => setLoad(data),
        authToken,
        user,
        panel = "resource"
      );
    }
  };
  const deleteResidentialType = (residential: string, index: number) => {
    if (resTypes) {
      setLoad(true);
      // deleteResidential(
      //   residential,
      //   user.organization_id,
      //   resTypes,
      //   index,
      //   dispatcher,
      //   (data) => setLoad(data)
      // );
      deleteResidentialMongo(
        residential,
        user.organization_id,
        resTypes,
        index,
        dispatcher,
        (data) => setLoad(data),
        authToken,
        user,
        panel = "resource"
      );
    }
  };
  const deleteTemplate = (item: any, index: number) => {
    if (templatesList) {
      // setLoad(true);
      deleteTemplateMongo(
        item,
        user.organization_id,
        templatesList,
        index,
        dispatcher,
        (data) => setLoading(data),
        authToken,
        user,
        panel = "resource",
      );
    }
  };

  // const deleteTemplate = (item: any, index: number) => {
  //   if (templatesList) {
  //     // setLoad(true);
  //     deleteTemplateMongo(
  //       item,
  //       user.organization_id,
  //       // templatesList,
  //       // index,
  //       dispatcher,
  //       (data) => setLoading(data),
  //       authToken,
  //       // user,
  //       // panel="resource",
  //     );
  //   }
  // };

  const deleteCommercialType = (commercial: string, index: number) => {
    if (comTypes) {
      setLoad(true);
      // deleteComType(
      //   commercial,
      //   user.organization_id,
      //   comTypes,
      //   index,
      //   dispatcher,
      //   (data) => setLoad(data)
      // );
      deleteComTypeMongo(
        commercial,
        user.organization_id,
        comTypes,
        index,
        dispatcher,
        (data) => setLoad(data),
        authToken,
        user,
        panel = "resource"
      );
    }
  };

  const deleteBusinessVerticalFirebase = (businessVertical: string, index: number) => {
    if (businessVerticalList) {
      setLoad(true);
      // deleteBusinessVertical(
      //   businessVertical,
      //   user.organization_id,
      //   businessVerticalList,
      //   index,
      //   dispatcher,
      //   (data) => setLoad(data)
      // );
      deleteBusinessVerticalMongo(
        businessVertical,
        user.organization_id,
        businessVerticalList,
        index,
        dispatcher,
        (data) => setLoad(data),
        authToken,
        user,
        panel = "resource"
      );
    }
  };

  const deleteAPIFormFirebase = (apiFormName: string, index: number) => {
    if (formNamesList) {
      setLoad(true);
      deleteAPIForm(
        apiFormName,
        user.organization_id,
        formNamesList,
        index,
        dispatcher,
        (data) => setLoad(data),
        user,
        panel = "resource",
        authToken
      );
    }
  };

  const deleteStateFirebase = (state: string, index: number) => {
    if (stateList) {
      setLoad(true);

      deleteState(
        state,
        user.organization_id,
        stateList,
        index,
        dispatcher,
        (data) => setLoad(data),
        authToken,
        user,
        panel = "resource"
      );
    }
  };

  //  const assignedWeights=async()=>{
  //   if (callDialed.label==undefined || wonLeads.label==undefined || promptness.label==undefined|| siteVisit.label==undefined || interested.label==undefined){
  //       dispatcher(showSnackbarAction("Please Select A Value", "error"));
  //   }else{
  //     const weights={
  //       totalCallsWeights: callDialed.label,
  //       totalWonWeights: wonLeads.label,
  //       totalMissedWeights: promptness.label,
  //       totalMeetingsWeights: siteVisit.label,
  //       totalInterestedWeights:interested.label
  //     }



  //       try {
  //         setLoad(true);
  //         axios.defaults.headers.common["x-access-token"] = authToken
  //         let res = await axios.post( "http://localhost:4000" + '/automatedScore/Create', {
  //           organization_id: user.organization_id,
  //           weights:weights

  //         })
  //       // console.log(res);

  //       }
  //       catch (error) {
  //         console.log("error",error);
  //       }
  //   }

  //   //  console.log("assigned weights",interested,callDialed,wonLeads,siteVisit,promptness);

  //         // console.log("assigned weights",interested.label,callDialed.label,wonLeads.label,siteVisit.label,promptness.label);



  //   }

  const onEdit = (
    type: "Location" | "Budget" | "Lead Source" | "Residential" | "Commercial" | "Business Vertical" | "API Forms" | "State" | 'Institutional' | 'Industrial',
    value: any,
    item:any
  ) => {
    setEditModalType(type);
    setEditModal(true);
    setEditValue(value);
    setEditObj(item);
  };

  const onEditTemplate = ((item: any) => {
    setTemplateName(item.template_name)
    setTemplateID(item.Id)
    setTemplateDetail(item.template_data)
    setEditTemplateModal(true)
  })
  useEffect(() => {
    let l: any = [];
    locationsList?.forEach((item) => {
      l.push(item.location_name);
    });
    setLocationNames(l);
  }, [locationsList]);

  useEffect(() => {
    let l: any = [];
    stateList?.forEach((item) => {
      l.push(item.state_name);
    });
    setStateNames(l);
  }, [stateList]);

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const thStyles = {
    backgroundColor: theme ? themeColors.thResourcesBackgroundColor : themeColors.thResourcesBackgroundColorDark
  }
  const thTextStyles = {
    color: theme ? themeColors.textPrimaryDark : themeColors.textPrimaryDark
  }
  const tdStyles = {
    backgroundColor: theme ? themeColors.tdBackgroundColor : themeColors.tdBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  }
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Resource_Panel',user)
      }
    }
  },[user])

  return (
    <>
      {/* {carouselList === undefined && <Loading />} */}
      <div className={styles.parent} style={containerStyles}>
        <div className={styles.child} style={containerStyles}>
          {loading && <Loading />}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "55%",
              // justifyContent: "space-between",
              ...containerStyles
            }}
          >
            <div className="card p-2 shadow rounded" style={{ height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px", ...cardContainerStyles }}>
              <div className="card-body" style={{ height: "100%" }}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable} >
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Image</th>
                          <th className={styles.th} style={thTextStyles}>Image Name</th>
                          <th className={styles.th} style={thTextStyles}>Created At</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {carouselList?.filter((item: any) => item.imageType === "IMAGE").map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td} style={tdStyles}>
                              <Image
                                src={item.url}
                                fluid
                                rounded
                                width="50%"
                              />
                            </td>
                            <td className={styles.td} style={tdStyles}>{item.imageName}</td>
                            <td className={styles.td} style={tdStyles}>
                              {getDateString3(item.created_at)}
                            </td>
                            <td className={styles.td} style={{ width: "40px", ...tdStyles }}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                onClick={() => {
                                  userPreference.resource_delete_approved === false ?
                                    dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                    :
                                    // deleteImage(index, item.image_name)
                                    deleteResourceMongo(user.organization_id,"carousel",item._id,dispatcher,setLoad,()=>{},authToken)
                                }}
                              />
                            </td>
                          </tr>
                        ))}

                      </tbody>
                    </Table>

                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addImageButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add Image","Resource Screen",user)
                        userPreference.resource_create_approved === false ?
                          dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                          :
                          setImportImageModal(true)
                      }}
                    >
                      ADD IMAGE
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer}  style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Edit</th>
                          <th className={styles.th} style={thTextStyles}>Lead Source</th>
                          <th className={styles.th} style={thTextStyles}>Created At</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leadSourceList?.map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td} style={tdStyles}>
                              <FiEdit3
                                size={15}
                                color="#279EA0"
                                onClick={() =>
                                  {
                                    userPreference.resource_update_approved === false?
                                    dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                    :
                                    onEdit("Lead Source", item.leadSource,item)}
                                }
                              />
                            </td>
                            <td className={styles.td} style={tdStyles}>{item.leadSource}</td>
                            <td className={styles.td} style={tdStyles}>
                              {getDateString3(item.created_at)}
                            </td>
                            <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                onClick={() =>
                                  {
                                    userPreference.resource_delete_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                  :
                                  deleteResourceMongo(user.organization_id,"leadSources",item._id,dispatcher,setLoad,()=>{},authToken)}
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add Lead Source","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                        setOpenLeadSource(true)}}
                    >
                      Add Lead Source
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {(organizationData.business_domain && organizationData.business_domain !== "Real Estate")&&(
                              <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
                              <div className="card-body" style={{height: "100%"}}>
                                <div className={styles.locationContainer}  style={cardContainerStyles}>
                                  <div className={styles.imageTable}>
                                    <Table striped bordered hover>
                                      <thead className={styles.head} style={thStyles}>
                                        <tr>
                                          <th className={styles.th} style={thTextStyles}>Edit</th>
                                          <th className={styles.th} style={thTextStyles}>Business Vertical</th>
                                          <th className={styles.th} style={thTextStyles}>Created At</th>
                                          <th className={styles.th} style={thTextStyles}>Delete</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {businessVerticalList?.map((item: any, index: number) => (
                                          <tr key={index}>
                                            <td className={styles.td} style={tdStyles}>
                                              <FiEdit3
                                                size={15}
                                                color="#279EA0"
                                                onClick={() =>
                                                 { userPreference.resource_update_approved === false?
                                                  dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                                  :
                                                   onEdit("Business Vertical", item.businessVertical,item)}
                                                }
                                              />
                                            </td>
                                            <td className={styles.td} style={tdStyles}>{item.businessVertical}</td>
                                            <td className={styles.td} style={tdStyles}>
                                              {getDateString3(item.created_at)}
                                            </td>
                                            <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                                              <MdDelete
                                                color={"#ff0000"}
                                                size={20}
                                                onClick={() =>
                                                  {userPreference.resource_delete_approved === false?
                                                    dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                                    :
                                                    deleteResourceMongo(user.organization_id,"businessVertical",item._id,dispatcher,setLoad,()=>{},authToken)}
                                                }
                                              />
                                            </td>
                                          </tr> 
                                        ))}
                                      </tbody>
                                    </Table>
                                  </div>
                                  <div className={styles.addLocationContainer}>
                                    <button
                                      className={styles.addButton}
                                      onClick={() => {
                                        googleAnalyticsCTAClick("Add Business Verticle","Resource Screen",user)
                                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                                        setOpenBusinessVertical(true)}}
                                    >
                                      Add Business Vertical
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
            )}
            {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
            <>
              <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Edit</th>
                          <th className={styles.th} style={thTextStyles}>Commercial Type</th>

                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {comTypes?.map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td} style={tdStyles}>
                              <FiEdit3
                                size={15}
                                color="#279EA0"
                                onClick={() => { userPreference.resource_update_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                  :
                                  onEdit("Commercial", item.comType,item)}}
                              />
                            </td>
                            <td className={styles.td} style={tdStyles}>{item.comType}</td>

                            <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                onClick={() => {
                                  userPreference.resource_delete_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                  :
                                  deleteResourceMongo(user.organization_id,"comTypes",item._id,dispatcher,setLoad,()=>{},authToken);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add Commercial","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                        setOpenCommercial(true)}}
                    >
                      Add Commercial Category
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Edit</th>
                          <th className={styles.th} style={thTextStyles}>Industrial Type</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {industrialTypes?.map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td}  style={tdStyles}>
                              <FiEdit3
                                size={15}
                                color="#279EA0"
                                onClick={() => {
                                  userPreference.resource_update_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                  :
                                  onEdit("Industrial", item.industrialType,item)}}
                              />
                            </td>
                            <td className={styles.td}  style={tdStyles}>{item.industrialType}</td>
                            <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                onClick={() => {
                                  userPreference.resource_delete_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                  :
                                  deleteResourceMongo(user.organization_id,"industrialTypes",item._id,dispatcher,setLoad,()=>{},authToken);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add Industrial","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                        dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                        :
                        setOpenIndustrial(true)}}
                    >
                      Add Industrial Category
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </>
            
            }
            <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}></th>
                          <th className={styles.th} style={thTextStyles}>Transfer Reason</th>

                          <th className={styles.th} style={thTextStyles}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {transferReasons?.map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td} style={tdStyles}>
                            </td>
                            <td className={styles.td} style={tdStyles}>{item.transferReason}</td>
                            <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                onClick={() => {
                                  userPreference.resource_delete_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                  :
                                  deleteResourceMongo(user.organization_id,"transferReasons",item._id,dispatcher,setLoad,()=>{},authToken);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add Transfer Reason","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                        setOpenTransferReason(true)}}
                    >
                      Add Transfer Reason
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Edit</th>
                          <th className={styles.th} style={thTextStyles}>Template Name</th>
                          <th className={styles.th} style={{...thTextStyles}}>Template Detail</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {templatesList?.map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td}  style={{...tdStyles}}>
                              <FiEdit3
                                size={15}
                                color="#279EA0"
                                style={{cursor:"pointer"}}
                                onClick={() => {
                                  userPreference.resource_update_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                  :
                                  onEditTemplate(item)}}
                              />
                            </td>
                            <td className={styles.td}  style={{...tdStyles}}>{item.template_name}</td>
                            <td className={styles.td}  style={{...tdStyles}}>{`${item.template_data.substring(0,50)}....`}</td>
                            <td className={styles.td} style={{...tdStyles}}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                style={{cursor:"pointer"}}
                                onClick={() => {
                                  userPreference.resource_delete_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                  :
                                  deleteResourceMongo(user.organization_id,"custom_templates",item._id,dispatcher,setLoad,()=>{},authToken);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add New Template","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                        setOpenTemplateModal(true)}}
                    >
                      Add New Template
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        
                          <h6 className={styles.th} style={thTextStyles}>Assigned weights</h6>
                        
                        
                      </thead>
                      <tbody>
     <div className={styles.divide}>
        <Label label="Call Dialed Weights" required={false} />
        <div style={{ marginTop: "7px",width:"150px",color:"#000"}}>
          <Dropdown
            
            option={weights}
            selectedValue={callDialed}
            setSelectedValue={(value) => {
              setCallDialed(value);
            }}          
          />
        </div>
      </div>
      <div className={styles.divide}>
        <Label label="Won Weights" required={false} />
        <div style={{ marginTop: "7px",width:"150px",color:"#000"}}>
          <Dropdown
            
            option={weights}
            selectedValue={wonLeads}
            setSelectedValue={(value) => {
              setWonLeads(value);
            }}
          />
        </div>
      </div>

      <div className={styles.divide}>
        <Label label="Site Visit Weights" required={false} />
        <div style={{ marginTop: "7px",width:"150px" ,color:"#000"}}>
          <Dropdown            
            option={weights}
            selectedValue={siteVisit}
            setSelectedValue={(value) => {
              setSiteVisit(value);
            }}
          />
        </div>
      </div>

      <div className={styles.divide}>
        <Label label="Interested Leads Weight" required={false} />
        <div style={{ marginTop: "7px",width:"150px",color:"#000"}}>
          <Dropdown
           
            option={weights}
            selectedValue={interested}
            setSelectedValue={(value) => {
              setInterested(value);
              
            }}
          />
        </div>
      </div>

      <div className={styles.divide}>
        <Label label="Promptness Weight" required={false} />
        <div style={{ marginTop: "7px",width:"150px",color:"#000"}}>
          <Dropdown
            
            option={negativeWeights}
            selectedValue={promptness}
            setSelectedValue={(value) => {
              setPromptness(value);
            }}
          />
        </div>
      </div>


                    </tbody>
       </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={assignedWeights}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          <div style={{
            display: "flex",
            flexDirection: "column",
            width: "55%",
            ...containerStyles
          }}>
            <div className="card p-2 shadow rounded" style={{height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Edit</th>
                          <th className={styles.th} style={thTextStyles}>Locations</th>
                          <th className={styles.th} style={thTextStyles}>Created At</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {locationsList?.map((item: any, index: number) => (
                          <>
                            <tr key={index}>
                              <td className={styles.td}  style={tdStyles}>
                                <FiEdit3
                                  size={15}
                                  color="#279EA0"
                                  onClick={() =>
                                    {
                                      userPreference.resource_update_approved === false?
                                      dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                      :
                                      onEdit("Location", item.location,item)}
                                  }
                                />
                              </td>
                              <td className={styles.td}  style={tdStyles}>{item.location}</td>
                              <td className={styles.td}  style={tdStyles}>
                                {getDateString3(item.created_at)}
                              </td>
                              <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                                <MdDelete
                                  color={"#ff0000"}
                                  size={20}
                                  onClick={() =>
                                    {userPreference.resource_delete_approved === false?
                                      dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                      :
                                      deleteResourceMongo(user.organization_id,"locations",item._id,dispatcher,setLoad,()=>{},authToken)}
                                  }
                                />
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add Location","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                        setOpenLocation(true)}}
                    >
                      Add Location
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-2 shadow rounded" style={{ marginTop: "20px",height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Edit</th>
                          <th className={styles.th} style={thTextStyles}>State</th>
                          <th className={styles.th} style={thTextStyles}>Created At</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {stateList?.map((item: any, index: number) => (
                          <>
                            <tr key={index}>
                              <td className={styles.td}  style={tdStyles}>
                                <FiEdit3
                                  size={15}
                                  color="#279EA0"
                                  onClick={() =>
                                    {
                                      userPreference.resource_update_approved === false?
                                      dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                      :
                                      onEdit("State", item.state,item)}
                                  }
                                />
                              </td>
                              <td className={styles.td}  style={tdStyles}>{item.state}</td>
                              <td className={styles.td}  style={tdStyles}>
                                {getDateString3(item.created_at)}
                              </td>
                              <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                                <MdDelete
                                  color={"#ff0000"}
                                  size={20}
                                  onClick={() =>
                                    {userPreference.resource_delete_approved === false?
                                      dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                      :
                                      deleteResourceMongo(user.organization_id,"states",item._id,dispatcher,setLoad,()=>{},authToken);}
                                  }
                                />
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add State","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                        setOpenState(true)}}
                    >
                      Add State
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Edit</th>
                          <th className={styles.th} style={thTextStyles}>Budgets</th>
                          <th className={styles.th} style={thTextStyles}>Created At</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {budgetsList?.map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td}  style={tdStyles}>
                              <FiEdit3
                                size={15}
                                color="#279EA0"
                                onClick={() => {
                                  userPreference.resource_update_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                  :
                                  onEdit("Budget", item.budget,item)}}
                              />
                            </td>
                            <td className={styles.td}  style={tdStyles}>{item.budget}</td>
                            <td className={styles.td}  style={tdStyles}>
                              {getDateString3(item.created_at)}
                            </td>
                            <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                onClick={() =>
                                  {userPreference.resource_delete_approved === false?
                                    dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                    :
                                    deleteResourceMongo(user.organization_id,"budgets",item._id,dispatcher,setLoad,()=>{},authToken);}
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add Budget","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                        setOpenBudget(true)}}
                    >
                      Add Budget
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
            <>
            <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Edit</th>
                          <th className={styles.th} style={thTextStyles}>Residential Type</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {resTypes?.map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td}  style={tdStyles}>
                              <FiEdit3
                                size={15}
                                color="#279EA0"
                                onClick={() => {
                                  userPreference.resource_update_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                  :
                                  onEdit("Residential", item.resType,item)}}
                              />
                            </td>
                            <td className={styles.td}  style={tdStyles}>{item.resType}</td>
                            <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                onClick={() => {
                                  userPreference.resource_delete_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                  :
                                  deleteResourceMongo(user.organization_id,"resTypes",item._id,dispatcher,setLoad,()=>{},authToken);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add Residential","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                        setOpenResidential(true)}}
                    >
                      Add Residential Category
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable}>
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Edit</th>
                          <th className={styles.th} style={thTextStyles}>Institutional Type</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {institutionalTypes?.map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td}  style={tdStyles}>
                              <FiEdit3
                                size={15}
                                color="#279EA0"
                                onClick={() =>{
                                  userPreference.resource_update_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                  :
                                  onEdit("Institutional", item.institutionalType,item)}}
                              />
                            </td>
                            <td className={styles.td}  style={tdStyles}>{item.institutionalType}</td>
                            <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                onClick={() => {
                                  userPreference.resource_delete_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                  :
                                  deleteResourceMongo(user.organization_id,"institutionalTypes",item._id,dispatcher,setLoad,()=>{},authToken);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add Institutional","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                        dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                        :
                        setOpenInstitutional(true)}}
                    >
                      Add Institutional Category
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </>
            }
            <div className="card p-2 shadow rounded" style={{marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles }}>
              <div className="card-body" style={{height: "100%"}}>
                <div className={styles.locationContainer} style={cardContainerStyles}>
                  <div className={styles.imageTable} >
                    <Table striped bordered hover>
                      <thead className={styles.head} style={thStyles}>
                        <tr>
                          <th className={styles.th} style={thTextStyles}>Logo</th>
                          <th className={styles.th} style={thTextStyles}>Logo Name</th>
                          <th className={styles.th} style={thTextStyles}>Created At</th>
                          <th className={styles.th} style={thTextStyles}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {carouselList?.filter((item: any) => item.imageType === "LOGO").map((item: any, index: number) => (
                          <tr key={index}>
                            <td className={styles.td} style={tdStyles}>
                              <Image
                                src={item.url}
                                fluid
                                rounded
                                width="50%"
                              />
                            </td>
                            <td className={styles.td} style={tdStyles}>{item.imageName}</td>
                            <td className={styles.td} style={tdStyles}>
                              {getDateString3(item.created_at)}
                            </td>
                            <td className={styles.td} style={{ width: "40px", ...tdStyles }}>
                              <MdDelete
                                color={"#ff0000"}
                                size={20}
                                onClick={() => {
                                  userPreference.resource_delete_approved === false ?
                                    dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                    :
                                    deleteResourceMongo(user.organization_id,"carousel",item._id,dispatcher,setLoad,()=>{},authToken);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                  </div>
                  <div className={styles.addLocationContainer}>
                    <button
                      className={styles.addImageButton}
                      onClick={() => {
                        googleAnalyticsCTAClick("Add LOGO","Resource Screen",user)
                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :
                        setImportLogoModal(true)}}
                    >
                      ADD LOGO
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-2 shadow rounded" style={{ marginTop: "20px", height: "65%", maxHeight:"450px", width: "96%", borderRadius: "20px",...cardContainerStyles}}>
                              <div className="card-body" style={{height: "100%"}}>
                                <div className={styles.locationContainer}  style={cardContainerStyles}>
                                  <div className={styles.imageTable}>
                                    <Table striped bordered hover>
                                      <thead className={styles.head} style={thStyles}>
                                        <tr>
                                          <th className={styles.th} style={thTextStyles}>Edit</th>
                                          <th className={styles.th} style={thTextStyles}>API Form</th>
                                          <th className={styles.th} style={thTextStyles}>Created At</th>
                                          <th className={styles.th} style={thTextStyles}>Delete</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {formNamesList?.map((item: any, index: number) => (
                                          <tr key={index}>
                                            <td className={styles.td} style={tdStyles}>
                                              <FiEdit3
                                                size={15}
                                                color="#279EA0"
                                                onClick={() =>
                                                  { userPreference.resource_update_approved === false?
                                                    dispatcher(showSnackbarAction('You are not allowed to edit a resource. Please contact your admin!!', 'error'))
                                                    :
                                                    onEdit("API Forms", item.apiForm,item)}
                                                }
                                              />
                                            </td>
                                            <td className={styles.td} style={tdStyles}>{item.apiForm}</td>
                                            <td className={styles.td} style={tdStyles}>
                                              {getDateString3(item.created_at)}
                                            </td>
                                            <td className={styles.td} style={{ width: "40px",...tdStyles }}>
                                              <MdDelete
                                                color={"#ff0000"}
                                                size={20}
                                                onClick={() =>
                                                  {userPreference.resource_delete_approved === false?
                                                    dispatcher(showSnackbarAction('You are not allowed to delete a resource. Please contact your admin!!', 'error'))
                                                    :
                                                    deleteResourceMongo(user.organization_id,"apiForms",item._id,dispatcher,setLoad,()=>{},authToken);}
                                                }
                                              />
                                            </td>
                                          </tr> 
                                        ))}
                                      </tbody>
                                    </Table>
                                  </div>
                                  <div className={styles.addLocationContainer}>
                                    <button
                                      className={styles.addButton}
                                      onClick={() => {
                                        googleAnalyticsCTAClick("Add Api Form","Resource Screen",user)
                                        userPreference.resource_create_approved === false?
                                  dispatcher(showSnackbarAction('You are not allowed to add a resource. Please contact your admin!!', 'error'))
                                  :setOpenForm(true)}}
                                    >
                                      Add API Form
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
          </div>
        </div>
        {openLocation && (
          <AddResources
            open={openLocation}
            close={() => setOpenLocation(false)}
            heading={"Location"}
            title={"Enter Location"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(showSnackbarAction("Enter Location!!", "error"));
            //   } else {
            //     setLoad(true);
            //     if (locationNames.includes(value)) {
            //       dispatcher(
            //         showSnackbarAction("This Location Already Exists!!", "info")
            //       );
            //       setLoad(false);
            //       setOpenLocation(false);
            //     } else {
            //       createLocation(
            //         user.organization_id,
            //         value,
            //         dispatcher,
            //         history,
            //         (data) => {
            //           setOpenLocation(data);
            //           setLoad(data);
            //         }
            //       );
            //     }
            //   }
            // }}
            type="locations"
            subType="location"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}
        {openTransferReason && (
          <AddResources
            open={openTransferReason}
            close={() => setOpenTransferReason(false)}
            heading={"Transfer Reason"}
            title={"Enter Reason"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(
            //       showSnackbarAction("Enter Transfer Reason!!", "error")
            //     );
            //   } else {
            //     setLoad(true);

            //     createTransferReason(
            //       user.organization_id,
            //       value,
            //       dispatcher,
            //       history,
            //       (data) => {
            //         setOpenTransferReason(data);
            //         setLoad(data);
            //       }
            //     );
            //   }
            // }}
            type="transferReasons"
            subType="transferReason"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}
        {openBudget && (
          <AddResources
            open={openBudget}
            close={() => setOpenBudget(false)}
            heading={"Budget"}
            title={"Enter Budget"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(showSnackbarAction("Enter Budget!!", "error"));
            //   } else {
            //     setLoad(true);
            //     createBudget(
            //       user.organization_id,
            //       value,
            //       dispatcher,
            //       history,
            //       (data) => {
            //         setOpenBudget(data);
            //         setLoad(data);
            //       }
            //     );
            //   }
            // }}
            type="budgets"
            subType="budget"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}
        {openLeadSource && (
          <AddResources
            open={openLeadSource}
            close={() => setOpenLeadSource(false)}
            heading={"Lead Source"}
            title={"Enter Lead Source"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(showSnackbarAction("Enter Lead Source!!", "error"));
            //   } else {
            //     setLoad(true);

            //     createLeadSource(
            //       user.organization_id,
            //       value,
            //       dispatcher,
            //       history,
            //       (data) => {
            //         setOpenLeadSource(data);
            //         setLoad(data);
            //       }
            //     );
            //   }
            // }}
            type="leadSources"
            subType="leadSource"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}
        {openBusinessVertical && (
          <AddResources
            open={openBusinessVertical}
            close={() => setOpenBusinessVertical(false)}
            heading={"Business Vertical"}
            title={"Enter Business Vertical"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(showSnackbarAction("Enter Business Vertical!!", "error"));
            //   } else {
            //     setLoad(true);

            //     createBusinessVertical(
            //       user.organization_id,
            //       value,
            //       dispatcher,
            //       history,
            //       (data) => {
            //         setOpenBusinessVertical(data);
            //         setLoad(data);
            //       }
            //     );
            //   }
            // }}
            type="businessVertical"
            subType="businessVertical"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}
        {openForm && (
          <AddResources
            open={openForm}
            close={() => setOpenForm(false)}
            heading={"API Form"}
            title={"Enter API Form Name"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(showSnackbarAction("Enter API Form Name!!", "error"));
            //   } else {
            //     setLoad(true);
            //     createAPIFormName(
            //       user.organization_id,
            //       value,
            //       dispatcher,
            //       history,
            //       (data) => {
            //         setOpenForm(data);
            //         setLoad(data);
            //       }
            //     );
            //   }
            // }}
            type="apiForms"
            subType="apiForm"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}
        {openCommercial && (
          <AddResources
            open={openCommercial}
            close={() => setOpenCommercial(false)}
            heading={"Commercial Type"}
            title={"Enter Commercial Type"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(
            //       showSnackbarAction("Enter Commercial Type!!", "error")
            //     );
            //   } else {
            //     setLoad(true);

            //     createCommercialType(
            //       user.organization_id,
            //       value,
            //       dispatcher,
            //       history,
            //       (data) => {
            //         setOpenCommercial(data);
            //         setLoad(data);
            //       }
            //     );
            //   }
            // }}
            type="comTypes"
            subType="comType"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}
        {openResidential && (
          <AddResources
            open={openResidential}
            close={() => setOpenResidential(false)}
            heading={"Residential Type"}
            title={"Enter Residential Type"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(
            //       showSnackbarAction("Enter Residential Type!!", "error")
            //     );
            //   } else {
            //     setLoad(true);

            //     createResidentialType(
            //       user.organization_id,
            //       value,
            //       dispatcher,
            //       history,
            //       (data) => {
            //         setOpenResidential(data);
            //         setLoad(data);
            //       }
            //     );
            //   }
            // }}
            type="resTypes"
            subType="resType"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}
        {openIndustrial && (
          <AddResources
            open={openIndustrial}
            close={() => setOpenIndustrial(false)}
            heading={"Industrial Type"}
            title={"Enter Industrial Type"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(
            //       showSnackbarAction("Enter Industrial Type!!", "error")
            //     );
            //   } else {
            //     setLoad(true);
            //     createIndustrialType(
            //       user.organization_id,
            //       value,
            //       dispatcher,
            //       history,
            //       (data) => {
            //         setOpenIndustrial(data);
            //         setLoad(data);
            //       }
            //     );
            //   }
            // }}
            type="industrialTypes"
            subType="industrialType"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}

        {openInstitutional && (
          <AddResources
            open={openInstitutional}
            close={() => setOpenInstitutional(false)}
            heading="Institutional Type"
            title="Enter Institutional Type"
            type="institutionalTypes"
            subType="institutionalType"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}


        {importImageModal && (
          <ImportImageModal
            open={importImageModal}
            close={() => setImportImageModal(false)}
            organization_id={user.organization_id}
            history={history}
          />
        )}
        {importLogoModal && (
          <ImportLogoModal
            open={importLogoModal}
            close={() => setImportLogoModal(false)}
            organization_id={user.organization_id}
            history={history}
          />
        )}
        {openTemplateModal && (
          <ImportTemplateModal
            open={openTemplateModal}
            close={() => setOpenTemplateModal(false)}
            heading={"Choose From These Fields"}
            title={"Enter Template Data"}
            onSave={(value: any, textareaValue: any) => {
              if (value === "") {
                dispatcher(showSnackbarAction("Enter Template!!", "error"));
              } else {
                // setLoad(true);
                {
                  createCustomTemplate(
                    user.organization_id,
                    value,
                    dispatcher,
                    history,
                    (data) => {
                      setOpenTemplateModal(data);
                      setLoading(data);
                    },
                    textareaValue,
                    user,
                    authToken,
                  );
                }
              }
            }}
          />
        )}
        {openState && (
          <AddResources
            open={openState}
            close={() => setOpenState(false)}
            heading={"State"}
            title={"Enter State"}
            // onSave={(value: any) => {
            //   if (value === "") {
            //     dispatcher(showSnackbarAction("Enter State!!", "error"));
            //   } else {
            //     setLoad(true);
            //     if (stateNames.includes(value)) {
            //       dispatcher(
            //         showSnackbarAction("This State Already Exists!!", "info")
            //       );
            //       setLoad(false);
            //       setOpenLocation(false);
            //     } 
            //     else {
            //       createState(
            //         user.organization_id,
            //         value,
            //         dispatcher,
            //         history,
            //         (data) => {
            //           setOpenState(data);
            //           setLoad(data);
            //         }
            //       );
            //     }
            //   }
            // }}
            type="states"
            subType="state"
            dispatcher={dispatcher}
            setLoad={(value) => setLoading(value)}
          />
        )}
        {editTemplateModal && (
          <EditTemplateModal
            open={editTemplateModal}
            close={() => setEditTemplateModal(false)}
            heading={"Choose From These Fields"}
            title={"Enter Template Data"}
            name1={templateName ? templateName : ""}
            detail={templateDetail ? templateDetail : ""}
            onSave={(value: any, textareaValue: any) => {
              if (value === "") {
                dispatcher(showSnackbarAction("Enter Template!!", "error"));
              } else {
                setLoad(true);
                {
                  editCustomTemplate(
                    user.uid,
                    user.organization_id,
                    value,
                    dispatcher,
                    history,
                    (data) => {
                      setEditTemplateModal(data);
                      setLoad(data);
                    },
                    textareaValue,
                    user.user_email,
                    authToken,
                    templateID
                  );
                }
              }
            }}
          />
        )}
        {editModal && (
          <EditResources
            open={editModal}
            title={`${editValue}`}
            heading={`Edit ${editModalType}`}
            close={() => setEditModal(false)}
            onSave={(newValue) => {
              setLoad(true);
              if (editModalType === "Budget") {
                // editBudget(
                //   user.organization_id,
                //   editValue,
                //   newValue,
                //   budgetsList,
                //   dispatcher,
                //   (val: boolean) => {
                //     setLoad(val);
                //     setEditModal(val);
                //   }
                // );
                editBudgetMongo(
                  user.uid,
                  editObj,
                  "budgets",
                  user.organization_id,
                  editValue,
                  newValue,
                  budgetsList,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              } else if (editModalType === "Lead Source") {
                // editLeadSource(
                //   user.organization_id,
                //   editValue,
                //   newValue,
                //   leadSourceList,
                //   dispatcher,
                //   (val: boolean) => {
                //     setLoad(val);
                //     setEditModal(val);
                //   }
                // );
                editLeadSourceMongo(
                  user.uid,
                  editObj,
                  "leadSources",
                  user.organization_id,
                  editValue,
                  newValue,
                  leadSourceList,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              } else if (editModalType === "Residential") {
                // editResType(
                //   user.organization_id,
                //   editValue,
                //   newValue,
                //   resTypes,
                //   dispatcher,
                //   (val: boolean) => {
                //     setLoad(val);
                //     setEditModal(val);
                //   }
                // );
                editResTypeMongo(
                  user.uid,
                  editObj,
                  "resTypes",
                  user.organization_id,
                  editValue,
                  newValue,
                  resTypes,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              } else if (editModalType === "Commercial") {
                // editCommType(
                //   user.organization_id,
                //   editValue,
                //   newValue,
                //   comTypes,
                //   dispatcher,
                //   (val: boolean) => {
                //     setLoad(val);
                //     setEditModal(val);
                //   }
                // );
                editCommTypeMongo(
                  user.uid,
                  editObj,
                  "comTypes",
                  user.organization_id,
                  editValue,
                  newValue,
                  comTypes,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              }
              else if (editModalType === "Business Vertical") {
                // editBusinessVertical(
                //   user.organization_id,
                //   editValue,
                //   newValue,
                //   businessVerticalList,
                //   dispatcher,
                //   (val: boolean) => {
                //     setLoad(val);
                //     setEditModal(val);
                //   }
                // );
                editBusinessVerticalMongo(
                  user.uid,
                  editObj,
                  "businessVertical",
                  user.organization_id,
                  editValue,
                  newValue,
                  businessVerticalList,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              }
              else if (editModalType === "API Forms") {
                editAPIForms(
                  user.uid,
                  editObj,
                  "apiForms",
                  user.organization_id,
                  editValue,
                  newValue,
                  formNamesList,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              }
              else if (editModalType === "State") {
                editState(
                  user.uid,
                  editObj,
                  "states",
                  user.organization_id,
                  editValue,
                  newValue,
                  stateList,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              }
              else if (editModalType === "Institutional") {
                editInstitutionalTypeMongo(
                  user.uid,
                  editObj,
                  "institutionalTypes",
                  user.organization_id,
                  editValue,
                  newValue,
                  institutionalTypes,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              }
              else if (editModalType === "Industrial") {
                editIndustrialTypeMongo(
                  user.uid,
                  editObj,
                  "industrialTypes",
                  user.organization_id,
                  editValue,
                  newValue,
                  industrialTypes,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              }
              else {
                // editLocation(
                //   user.organization_id,
                //   editValue,
                //   newValue,
                //   locationsList,
                //   dispatcher,
                //   (val: boolean) => {
                //     setLoad(val);
                //     setEditModal(val);
                //   }
                // );
                editLocationMongo(
                  user.uid,
                  editObj,
                  "locations",
                  user.organization_id,
                  editValue,
                  newValue,
                  locationsList,
                  dispatcher,
                  (val: boolean) => {
                    setLoad(val);
                    setEditModal(val);
                  },
                  authToken
                );
              }
            }}
            type={editModalType}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    contacts: state.contacts,
    theme: state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    authToken: state.user.authToken,
    userPreference: state.userPreference.data,
    organizationResources:state.organizationResources.data
  };
};

export default connect(mapStateToProps)(Resources);
